/* eslint-disable no-useless-catch */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiget } from '../../service/api';

export const fetchWAgroupData = createAsyncThunk('fetchWAgroupData', async () => {
    const userid = sessionStorage.getItem('user_id');
    const userRole = sessionStorage.getItem("userRole");
    try {
        const response = await apiget(`api/whatsapp/groups`);
        return response?.data?.result;
    } catch (error) {
        throw error;
    }
});

const WAgroupSlice = createSlice({
    name: 'WAgroupDetails',
    initialState: {
        data: [],
        isLoading: false,
        error: "",
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchWAgroupData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchWAgroupData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
                state.error = "";
            })
            .addCase(fetchWAgroupData.rejected, (state, action) => {
                state.isLoading = false;
                state.data = [];
                state.error = action.error.message;
            });
    },
});

export default WAgroupSlice.reducer;